import { ICity } from '@/types/types';

export interface CitySearchResponse {
    count: number;
    next: null;
    previous: null;
    results: CitiesResult[];
}

interface CitiesResult {
    id: number;
    url: string;
    sks_code: string;
    iata_code: string;
    timezone: string;
    latitude: string;
    longitude: string;
    sort_order: number;
    name: string;
    state_province_name: string | null;
    country: CityCountry;
    image: string | null;
}

interface CityCountry {
    id: number;
    name: string;
    url: string;
    sks_code: string;
    iata_code: string | null;
    timezone: string | null;
    currency: string;
}

const adaptCities = (cities: CitiesResult[]): ICity[] => {
    return cities.map((city) => {
        return {
            id: city.id,
            name: city.name,
            countryCode: city.country.sks_code,
            countryName: city.country.name ?? '',
            iataCode: city.iata_code ?? '',
        };
    });
};

export default adaptCities;
